
import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';


import { CommonServe } from '../services/api/CommonServ'


const FileUploader = ({ open ,handleCloseUploader}) => {
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);
    const [visible, setVisible] = useState(open);
    const [width , setWidth] = useState(null);
    const [height , setHeight] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const measuringUnits = ['%' ,'px']
    const fileUploadRef = useRef(null);
    const [selectedWidthUnit, setselectedWidthUnit] = useState('px');
    const [selectedHeightUnit, setselectedHeightUnit] = useState('px');
  
    const handleClose = (res=null)=>{
        handleCloseUploader(res,`${width + selectedWidthUnit}`,`${height + selectedHeightUnit}`);
        setVisible(false);
    }

    const changeWidth = (event) =>{
        if(event.target.value !== ''){
            setWidth(event.target.value);
        } else {
            setWidth(null);
        }
    }

    const changeHeight = (event) => {
        if(event.target.value !== ''){
        setHeight(event.target.value);
        } else {
            setHeight(null);
        }
    } 

    const handleWidthUnitChange = (event) => {
        setselectedWidthUnit(event.target.value);
    };

    const handleHeightUnitChange = (event) => {
        setselectedHeightUnit(event.target.value);
    };

    const onTemplateSelect = (e) => {
        setSelectedFiles(e.files)
        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);
    };

   

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };
    const handleCustomUpload = async () => {
        const formData = new FormData();
        console.log(selectedFiles)
        if (selectedFiles.length > 0) {
            formData.append('file',selectedFiles[0])
            try {
                let res = await CommonServe.uploadfiletos3(formData);
                onTemplateClear();
                onTemplateClear();
                handleClose(res);
                toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
                console.log(width , height);

            //     if(width !== '' && width !== null && width !== undefined){
            //         if(((selectedWidthUnit ===  '%' && width > 20) || (selectedWidthUnit === 'px' && width >= 200))){
            //             handleClose(res)
            //         } else {
            //             if(selectedWidthUnit === '%'){
            //             toast.current.show({ severity: 'error', summary: 'Error', detail: `The Set Width Should not be less than 20%` });
            //             } else {
            //             toast.current.show({ severity: 'error', summary: 'Error', detail: `The Set Width Should not be less than 200px` });
            //             }
            //         }
            //     }
            //    else if(height !== '' && height !== null && height !== undefined ){
            //     if(((selectedHeightUnit === '%' && height > 10) || (selectedHeightUnit === 'px' && height >= 100))){
            //         handleClose(res)
            //     } else {
            //         if(selectedWidthUnit === '%'){
            //             toast.current.show({ severity: 'error', summary: 'Error', detail: `The Set Height Should not be less than 10%` });
            //             } else {
            //             toast.current.show({ severity: 'error', summary: 'Error', detail: `The Set Height Should not be less than 100px` });
            //             }
            //     }
            //    } else {
            //     handleClose(res);
            //     toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
            //    }
            
            } catch (error) {
                console.log(error)
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'File Upload' });
            } finally {

            }
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select atleast one file' });
        }
    }


    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'end' }}>
                <div className="flex align-items-center gap-3 ml-auto">
                {chooseButton}
                <Button icon="pi pi-upload" rounded outlined severity="success" aria-label="Upload" disabled={selectedFiles.length === 0} onClick={handleCustomUpload} />
                {cancelButton}
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    return (
        <div>
            <Toast ref={toast}></Toast>
            <Dialog header="Upload File" visible={visible} style={{ width: '50vw' }} onHide={() => handleClose()}>
                <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
                <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

                <FileUpload ref={fileUploadRef} name="file" multiple accept="image/*" maxFileSize={1000000}
                    onSelect={onTemplateSelect} onClear={onTemplateClear}
                    headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
            
            <div>
                <form>
                <div className="grid">
                <div
                  className={`col-6`}
                  style={{ marginTop: "20px"}}
                >
                  <label htmlFor="email">Width :</label>
                  <br />
                  <input
                    style={{
                        width: '50%',
                        padding: '15px',
                        borderRadius: '12px 0px 0px 12px',
                        marginTop: '10px',
                        borderColor: 'rgba(0, 0, 0, 0.16)'
                    }}
                    type="text"
                    id="width"
                    name="width"
                    value = {width}
                    onChange={changeWidth}
                  />
                    <select  value={selectedWidthUnit} onChange={handleWidthUnitChange}
                    style={{height: '50px',
                        width: '59px',
                        padding: '4px',
                        border: '2px solid rgba(0, 0, 0, 0.16)',
                        borderRadius: '0px 12px 12px 0px'}}>
                    {measuringUnits.map((unit) => (
                        <option key={unit} value={unit}>
                        {unit}
                        </option>
                    ))}
                    </select>
                </div>

                <div
                   className={`col-6`}
                  style={{ marginTop: "20px" }}
                >
                  <label htmlFor="email">Height :</label>
                  <br />
                  <input
                    style={{
                        width: '50%',
                        padding: '15px',
                        borderRadius: '12px 0px 0px 12px',
                        marginTop: '10px',
                        borderColor: 'rgba(0, 0, 0, 0.16)'
                    }}
                    type="text"
                    id="height"
                    name="height"
                    value = {height}
                    onChange={changeHeight}
                  />
                      <select value={selectedHeightUnit} onChange={handleHeightUnitChange}
                    style={{height: '50px',
                        width: '59px',
                        padding: '4px',
                        border: '2px solid rgba(0, 0, 0, 0.16)',
                        borderRadius: '0px 12px 12px 0px'}}>
                    {measuringUnits.map((unit) => (
                        <option key={unit} value={unit}>
                        {unit}
                        </option>
                    ))}
                    </select>
                  <br />
                </div>
              </div>
                </form>
            </div>
            </Dialog>

          
        </div>
       
    )
}

export default FileUploader